<template>
  <div class="speedee-regular col-sm-12 py-5">
    <ImageComponent @add-image="handleAddImage($event)" />

    <LastUpdated :tableData="myTableData" :tableColumns="myTableColumns" :buttons="buttons" @click="handleClick"
      :getClass="getClass" :blockStatus="blockStatus" :lastUpdated="lastUpdated" />

    <h3 class="flex-grow-1 speedee-bold p-2">McD App</h3>

    <!-- Banner Section -->
    <div class="card">
      <div class="card-header text-center d-flex" :style="{
        backgroundColor: this.banner.approval === 'Pending' ? '#ffc107' : 'black',
        padding: '10px',
        color: 'white',
      }">
        <h5 class="flex-grow-1">Banner</h5>
        <span v-if="this.banner.approval === 'Pending'" class="float-right btn bg-secondary"><i
            class="fa fa-lock text-white"></i></span>
      </div>
      <div class="card-body">
        <div class="col-4">
          <div style="display: flex; flex-direction: column">
            <div style="
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                      ">
              <img :src="banner.image_url" style="
                          width: 120px;
                          height: 120px;
                          object-fit: contain;
                          border-radius: 10px;
                          border: dashed 1px gray;
                        " />
              <div v-if="!isApprover && this.banner.approval !== 'Pending'"
                class="fileUpload bg-none text-left align-middle d-block">
                <div>
                  <span class="media-text p-2">Select from Media Library (Max dimension 1200 x 800
                    px)</span>
                </div>
                <button @click="openGalleryModal('banner')" aria-hidden="true" class="mx-2 p-2 border w-auto">
                  Browse...
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="float-right">
          <button @click="bannerButtonPreview" class="btn btn-light m-2">Preview
          </button>
          <button v-if="!isApprover && banner.approval !== 'Pending'" @click="bannerButtonDraft"
            class="btn btn-light m-2">Save Draft
          </button>
          <button v-if="!isApprover && banner.approval !== 'Pending'" @click="bannerButtonSubmit"
            class="btn btn-warning m-2">
            Submit For Approval
          </button>
          <button v-if="isApprover && banner.approval === 'Pending'" data-bs-toggle="modal" data-bs-target="#approveModal"
            class="btn btn-warning m-2 approveModal" @click="openApprovalModal('banner')">
            Approval
          </button>
        </div>
      </div>
    </div>

    <!-- Video Section -->
    <div class="card">
      <div class="card-header text-center d-flex" :style="{
        backgroundColor: this.video.approval === 'Pending' ? '#ffc107' : 'black',
        padding: '10px',
        color: 'white',
      }">
        <h5 class="flex-grow-1">Watch How It Works</h5>
        <span v-if="this.video.approval === 'Pending'" class="float-right btn bg-secondary"><i
            class="fa fa-lock text-white"></i></span>
      </div>
      <div class="card-body">
        <h5 class="fw-bold">Description</h5>
        <textarea class="form-control border-dark mb-5" name="" id="video" cols="10" rows="2"
          v-model="video.description"></textarea>

        <h5 class="fw-bold">Video</h5>
        <p class="text-danger">* Must use embed url</p>
        <p>YouTube video -> Click Share -> Embed -> Get the youtube URL from src="URL"</p>
        <textarea class="form-control border-dark mb-5" name="video" id="video" cols="3" rows="1"
          v-model="video.video_url"></textarea>

        <div class="float-right">
          <button @click="videoButtonPreview" class="btn btn-light m-2">Preview
          </button>
          <button v-if="!isApprover && video.approval !== 'Pending'" @click="videoButtonDraft" class="btn btn-light m-2">
            Save Draft
          </button>
          <button v-if="!isApprover && video.approval !== 'Pending'" @click="videoButtonSubmit"
            class="btn btn-warning m-2">
            Submit For Approval
          </button>
          <button v-if="isApprover && video.approval === 'Pending'" data-bs-toggle="modal" data-bs-target="#approveModal"
            class="btn btn-warning m-2 approveModal" @click="openApprovalModal('video')">
            Approval
          </button>
        </div>
      </div>
    </div>

    <!-- McDonald's App Section -->
    <div class="card">
      <div class="card-header text-center d-flex" :style="{
        backgroundColor: this.apps.approval === 'Pending' ? '#ffc107' : 'black',
        padding: '10px',
        color: 'white',
      }">
        <h5 class="flex-grow-1">McDonald's App</h5>
        <span v-if="this.apps.approval === 'Pending'" class="float-right btn bg-secondary"><i
            class="fa fa-lock text-white"></i></span>
      </div>
      <div class="card-body">
        <h5 class="fw-bold">Image</h5>
        <div class="col-4">
          <div style="display: flex; flex-direction: column">
            <div style="
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                      ">
              <img :src="apps.image_url" style="
                          width: 120px;
                          height: 120px;
                          object-fit: contain;
                          border-radius: 10px;
                          border: dashed 1px gray;
                        " />
              <div v-if="!isApprover && this.apps.approval !== 'Pending'"
                class="fileUpload bg-none text-left align-middle d-block">
                <div>
                  <span class="media-text p-2">Select from Media Library (Max dimension 1200 x 800
                    px)</span>
                </div>
                <button @click="openGalleryModal('apps')" aria-hidden="true" class="mx-2 p-2 border w-auto">
                  Browse...
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="float-right">
          <button @click="appButtonPreview" class="btn btn-light m-2">Preview
          </button>
          <button v-if="!isApprover && apps.approval !== 'Pending'" @click="appButtonDraft" class="btn btn-light m-2">
            Save Draft
          </button>
          <button v-if="!isApprover && apps.approval !== 'Pending'" @click="appButtonSubmit"
            class="btn btn-warning m-2">Submit For Approval
          </button>
          <button v-if="isApprover && apps.approval === 'Pending'" data-bs-toggle="modal" data-bs-target="#approveModal"
            class="btn btn-warning m-2 approveModal" @click="openApprovalModal('apps')">
            Approval
          </button>
        </div>
      </div>
    </div>

    <!-- McDonald's Deals Section -->
    <div class="card">
      <div class="card-header text-center d-flex" :style="{
        backgroundColor: this.deal.approval === 'Pending' ? '#ffc107' : 'black',
        padding: '10px',
        color: 'white',
      }">
        <h5 class="flex-grow-1">McDonald's Deals</h5>
        <span v-if="this.deal.approval === 'Pending'" class="float-right btn bg-secondary"><i
            class="fa fa-lock text-white"></i></span>
      </div>
      <div class="card-body">
        <h5 class="fw-bold">Description</h5>
        <textarea class="form-control border-dark mb-5" name="" id="deal" cols="10" rows="2"
          v-model="deal.description"></textarea>

        <h5 class="fw-bold">Image</h5>
        <div class="col-4">
          <div style="display: flex; flex-direction: column">
            <div style="
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                      ">
              <img :src="deal.image_url" style="
                          width: 120px;
                          height: 120px;
                          object-fit: contain;
                          border-radius: 10px;
                          border: dashed 1px gray;
                        " />
              <div v-if="!isApprover && this.deal.approval !== 'Pending'"
                class="fileUpload bg-none text-left align-middle d-block">
                <div>
                  <span class="media-text p-2">Select from Media Library (Max dimension 1200 x 800
                    px)</span>
                </div>
                <button @click="openGalleryModal('deal')" aria-hidden="true" class="mx-2 p-2 border w-auto">
                  Browse...
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="float-right">
          <button @click="dealsButtonPreview" class="btn btn-light m-2">Preview
          </button>
          <button v-if="!isApprover && deal.approval !== 'Pending'" @click="dealsButtonDraft" class="btn btn-light m-2">
            Save Draft
          </button>
          <button v-if="!isApprover && deal.approval !== 'Pending'" @click="dealsButtonSubmit"
            class="btn btn-warning m-2">Submit For Approval
          </button>
          <button v-if="isApprover && deal.approval === 'Pending'" data-bs-toggle="modal" data-bs-target="#approveModal"
            class="btn btn-warning m-2 approveModal" @click="openApprovalModal('deal')">
            Approval
          </button>
        </div>
      </div>
    </div>

    <!-- Steps Section -->
    <div class="card">
      <div class="card-header text-center d-flex" :style="{
        backgroundColor: this.steps.approval === 'Pending' ? '#ffc107' : 'black',
        padding: '10px',
        color: 'white',
      }">
        <h5 class="flex-grow-1">Experience the McD App Now!</h5>
        <span v-if="this.steps.approval === 'Pending'" class="float-right btn bg-secondary"><i
            class="fa fa-lock text-white"></i></span>
      </div>
      <div class="card-body">
        <h5 class="fw-bold">Description</h5>
        <textarea class="form-control border-dark mb-5" name="" id="" cols="10" rows="2"
          v-model="steps.description"></textarea>

        <h5 class="fw-bold">Image</h5>
        <div class="col-4">
          <div style="display: flex; flex-direction: column">
            <div style="
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                      ">
              <img :src="steps.image_url" style="
                          width: 120px;
                          height: 120px;
                          object-fit: contain;
                          border-radius: 10px;
                          border: dashed 1px gray;
                        " />
              <div v-if="!isApprover && this.steps.approval !== 'Pending'"
                class="fileUpload bg-none text-left align-middle d-block">
                <div>
                  <span class="media-text p-2">Select from Media Library (Max dimension 1200 x 800
                    px)</span>
                </div>
                <button @click="openGalleryModal('steps')" aria-hidden="true" class="mx-2 p-2 border w-auto">
                  Browse...
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="float-right">
          <ApprovalComponent @submit-data="handleData($event)" :datas="datas" />
          <button @click="stepsButtonPreview" class="btn btn-light m-2">Preview
          </button>
          <button v-if="!isApprover && steps.approval !== 'Pending'" @click="stepsButtonDraft" class="btn btn-light m-2">
            Save Draft
          </button>
          <button v-if="!isApprover && steps.approval !== 'Pending'" @click="stepsButtonSubmit"
            class="btn btn-warning m-2">
            Submit For Approval
          </button>
          <button v-if="isApprover && steps.approval === 'Pending'" data-bs-toggle="modal" data-bs-target="#approveModal"
            class="btn btn-warning m-2 approveModal" @click="openApprovalModal('steps')">
            Approval
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DropFile from "@/components/DropFile.vue";
import FileUploadComponent from "@/components/FileUploadComponent.vue";
import LastUpdated from "./Faqs/LastUpdated.vue";
import { getRequest, postRequest } from "@/services/RequestService";
import ImageComponent from "@/components/ImageComponent.vue";
import ApprovalComponent from "@/components/ApprovalComponent.vue";
import { checkUserRole } from "@/services/Auth.js";

export default {
  components: {
    DropFile,
    FileUploadComponent,
    LastUpdated,
    ImageComponent,
    ApprovalComponent,
  },

  data() {
    return {
      banner: [],
      apps: [],
      deal: [],
      steps: [],
      video: [],
      isApprover: false,
      datas: [],

      // for search purposes
      myTableColumns: [
        { field: "description" },
        { field: "author" },
        { field: "status" },
        { field: "approved_by" },
        { field: "remarks" },
        { field: "statusText" },
      ],
      originalMyTableData: [],
      myTableData: [],

      headerClass: "table-dark",
      activeIndex: null,
      buttons: [
        { id: null, status: true, name: "All" },
        { id: 2, status: false, name: "Approved" },
        { id: 1, status: false, name: "Pending" },
        { id: 4, status: false, name: "Rejected" },
        { id: 3, status: false, name: "Expired" },
      ],
    };
  },
  methods: {
    async checkUserRole() {
      this.isApprover = await checkUserRole();
    },

    async loadApps() {
      try {
        let response = await getRequest("/apps/create");

        if (response.data.success === false) {
          throw new Error("Error encountered. Please try again.");
        }

        this.banner = response.data.data.banner;
        this.apps = response.data.data.app;
        this.deal = response.data.data.deal;
        this.steps = response.data.data.steps;
        this.video = response.data.data.video;
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
    },

    getClass(status) {
      switch (status) {
        case 2:
          return "text-success";
        case 1:
          return "text-warning";
        case 4:
          return "text-danger";
        case 3:
          return "text-brown";
        default:
          return "text-grey";
      }
    },

    blockStatus(status) {
      switch (status) {
        case 2:
          return "bg-light-success";
        case 1:
          return "bg-light-warning";
        case 4:
          return "bg-light-danger";
        case 3:
          return "bg-light-brown";
        default:
          return "bg-light-dark";
      }
    },

    async getUpdatedData() {
      try {
        const response = await getRequest("/apps/create");

        if (response.data.success == false) {
          throw new Error("Error encountered. Please try again.");
        }
        this.myTableData = response.data.data.logs;
        this.originalMyTableData = response.data.data.logs;
        this.lastUpdated = response.data.data.last_updated_at;
      } catch (e) {
        swal({
          icon: "error",
          text: e.message,
        });
      }
    },

    openGalleryModal(section) {
      console.log("Open Gallery for:", section);

      document.getElementById("modal_id").value = section;

      var galleryModal = document.getElementById("galleryModal");
      galleryModal.classList.add("show");
      galleryModal.style.display = "block";
    },

    handleAddImage(galleryId) {
      console.log(
        "Added image with ID:",
        galleryId,
        "For Section:",
        galleryId.modalName
      );

      if (galleryId.modalName == "banner") {
        this.banner.image_url = galleryId.galleryUrl;
        this.banner.gallery_id = galleryId.galleryId;
      }
      if (galleryId.modalName == "apps") {
        this.apps.image_url = galleryId.galleryUrl;
        this.apps.gallery_id = galleryId.galleryId;
      }
      if (galleryId.modalName == "deal") {
        this.deal.image_url = galleryId.galleryUrl;
        this.deal.gallery_id = galleryId.galleryId;
      }
      if (galleryId.modalName == "steps") {
        this.steps.image_url = galleryId.galleryUrl;
        this.steps.gallery_id = galleryId.galleryId;
      }
    },

    openApprovalModal(section) {
      document.getElementById("data_id").value = section;
    },

    handleData(entityData) {
      if (entityData.dataName === "banner") {
        this.datas = this.banner;
      } else if (entityData.dataName === "video") {
        this.datas = this.video;
      } else if (entityData.dataName === "apps") {
        this.datas = this.apps;
      } else if (entityData.dataName === "deal") {
        this.datas = this.deal;
      } else if (entityData.dataName === "steps") {
        this.datas = this.steps;
      }
    },

    async handleClick(type, int) {
      this.buttons.forEach((button) => {
        button.status = int === button.id;
      });

      this.changeFilter(int);
    },

    async changeFilter(id) {
      if (id == null) {
        this.myTableData = this.originalMyTableData;
      } else {
        this.myTableData = this.originalMyTableData.filter(
          (item) => parseInt(item.status) === parseInt(id)
        );
      }
    },

    //Banner Section
    async bannerButtonPreview() {
      if (this.banner.approval == 'Pending' || (this.banner.approval == 'Approved' && this.isApprover)) {
        window.open("/mcd-app?preview=1");
      } else {
        let postData = {
          image: this.banner.gallery_id
            ? this.banner.gallery_id
            : this.banner.image_id,
          approval: false,
        };

        let response;
        if (this.banner.approval === "Draft") {
          response = await postRequest("/apps/banner/" + this.banner.id, postData);
        } else {
          response = await postRequest("/apps/banner/", postData);
        }

        if (response.data.success) {
          window.open("/mcd-app?preview=1", "_blank");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }
      }
    },
    bannerButtonDraft() {
      this.bannerSubmission(this.banner, 0);
    },
    bannerButtonSubmit() {
      this.bannerSubmission(this.banner, 1);
    },

    async bannerSubmission(data, approval) {
      try {
        let post_request = this._bannerRequest(data);
        post_request.approval = approval;

        let response;
        if (this.banner.approval === "Draft") {
          response = await postRequest("/apps/banner/" + this.banner.id, post_request);
        } else {
          response = await postRequest("/apps/banner", post_request);
        }

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _bannerRequest(data) {
      return {
        image: this.banner.gallery_id
          ? this.banner.gallery_id
          : this.banner.image_id,
        status: 0,
      };
    },

    //Video Section
    async videoButtonPreview() {
      if (this.video.approval == 'Pending' || (this.video.approval == 'Approved' && this.isApprover)) {
        window.open("/mcd-app?preview=1");
      } else {
        let postData = {
          description: this.video.description,
          video_url: this.video.video_url,
          approval: false,
        };

        let response;
        if (this.video.approval === "Draft") {
          response = await postRequest("/apps/video/" + this.video.id, postData);
        } else {
          response = await postRequest("/apps/video/", postData);
        }

        if (response.data.success) {
          window.open("/mcd-app?preview=1", "_blank");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }
      }
    },
    videoButtonDraft() {
      this.videoSubmission(this.video, 0);
    },
    videoButtonSubmit() {
      this.videoSubmission(this.video, 1);
    },

    async videoSubmission(data, approval) {
      try {
        let post_request = this._videoRequest(data);
        post_request.approval = approval;

        let response;
        if (this.video.approval === "Draft") {
          response = await postRequest("/apps/video/" + this.video.id, post_request);
        } else {
          response = await postRequest("/apps/video", post_request);
        }

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _videoRequest(data) {
      return {
        description: data.description,
        video_url: data.video_url,
        status: 0,
      };
    },

    //Apps Section
    async appButtonPreview() {
      if (this.apps.approval == 'Pending' || (this.apps.approval == 'Approved' && this.isApprover)) {
        window.open("/mcd-app?preview=1");
      } else {
        let postData = {
          image: this.apps.gallery_id
            ? this.apps.gallery_id
            : this.apps.image_id,
          approval: false,
        };

        let response;
        if (this.apps.approval === "Draft") {
          response = await postRequest("/apps/mcd-app/" + this.apps.id, postData);
        } else {
          response = await postRequest("/apps/mcd-app/", postData);
        }

        if (response.data.success) {
          window.open("/mcd-app?preview=1", "_blank");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }
      }
    },
    appButtonDraft() {
      this.appSubmission(this.apps, 0);
    },
    appButtonSubmit() {
      this.appSubmission(this.apps, 1);
    },

    async appSubmission(data, approval) {
      try {
        let post_request = this._appRequest(data);
        post_request.approval = approval;

        let response;
        if (this.apps.approval === "Draft") {
          response = await postRequest("/apps/mcd-app/" + this.apps.id, post_request);
        } else {
          response = await postRequest("/apps/mcd-app", post_request);
        }

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _appRequest(data) {
      return {
        image: this.apps.gallery_id
          ? this.apps.gallery_id
          : this.apps.image_id,
        status: 0,
      };
    },

    //Deals Section
    async dealsButtonPreview() {
      if (this.deal.approval == 'Pending' || (this.deal.approval == 'Approved' && this.isApprover)) {
        window.open("/mcd-app?preview=1");
      } else {
        let postData = {
          description: this.deal.description,
          image: this.deal.gallery_id
            ? this.deal.gallery_id
            : this.deal.image_id,
          approval: false,
        };

        let response;
        if (this.deal.approval === "Draft") {
          response = await postRequest("/apps/deal/" + this.deal.id, postData);
        } else {
          response = await postRequest("/apps/deal/", postData);
        }

        if (response.data.success) {
          window.open("/mcd-app?preview=1", "_blank");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }
      }
    },
    dealsButtonDraft() {
      this.dealSubmission(this.deal, 0);
    },
    dealsButtonSubmit() {
      this.dealSubmission(this.deal, 1);
    },

    async dealSubmission(data, approval) {
      try {
        let post_request = this._dealRequest(data);
        post_request.approval = approval;

        let response;
        if (this.deal.approval === "Draft") {
          response = await postRequest("/apps/deal/" + this.deal.id, post_request);
        } else {
          response = await postRequest("/apps/deal", post_request);
        }

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _dealRequest(data) {
      return {
        description: data.description,
        image: this.deal.gallery_id ? this.deal.gallery_id : this.deal.image_id,
        status: 0,
      };
    },

    //Steps Section
    async stepsButtonPreview() {
      if (this.steps.approval == 'Pending' || (this.steps.approval == 'Approved' && this.isApprover)) {
        window.open("/mcd-app?preview=1");
      } else {
        let postData = {
          description: this.steps.description,
          image: this.steps.gallery_id
            ? this.steps.gallery_id
            : this.steps.image_id,
          approval: false,
        };

        let response;
        if (this.steps.approval === "Draft") {
          response = await postRequest("/apps/steps/" + this.steps.id, postData);
        } else {
          response = await postRequest("/apps/steps/", postData);
        }

        if (response.data.success) {
          window.open("/mcd-app?preview=1", "_blank");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }
      }
    },
    stepsButtonDraft() {
      this.stepSubmission(this.steps, 0);
    },
    stepsButtonSubmit() {
      this.stepSubmission(this.steps, 1);
    },

    async stepSubmission(data, approval) {
      try {
        let post_request = this._stepRequest(data);
        post_request.approval = approval;

        let response;
        if (this.steps.approval === "Draft") {
          response = await postRequest("/apps/steps/" + this.steps.id, post_request);
        } else {
          response = await postRequest("/apps/steps", post_request);
        }

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _stepRequest(data) {
      return {
        description: data.description,
        image: this.steps.gallery_id
          ? this.steps.gallery_id
          : this.steps.image_id,
        status: 0,
      };
    },
  },

  async mounted() {
    this.checkUserRole();
    await this.loadApps();
    await this.getUpdatedData();
  },
};
</script>

<style scoped>
.table-responsive {
  border-radius: 10px;
  background-color: white;
  box-shadow: 0px 9px 20px rgba(46, 35, 94, 0.07);
}
</style>
